import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion } from "framer-motion";
import { useState } from "react";
import Slider from "react-slick";
import styled from "styled-components";
import { Arrow, SlideItem } from "./styled.components";
import { MusicDetail, MusicImage } from "./styled.components";
import { MusicSliderDataTypes } from "./types";
import NormalSlider from "./NormalSlider";

const Container = styled(motion.div)``;

export enum MusicSliderType {
  NORMAL = "normal",
  DEFAULT = "default",
}

interface MerchSliderProps {
  data: MusicSliderDataTypes[];
  type?: MusicSliderType;
}

export default function MusicSlider({
  data,
  type = MusicSliderType.DEFAULT,
}: MerchSliderProps) {
  const [selectedIdx, setSelectedIdx] = useState<number>(0);

  const ArrowPrev = (props: any) => {
    const { onClick } = props;
    return (
      <Arrow type="button" left="10%" className="from-lef" onClick={onClick}>
        <FontAwesomeIcon icon={faAngleLeft as any} />
      </Arrow>
    );
  };

  const ArrowNext = (props: any) => {
    const { onClick } = props;

    return (
      <Arrow type="button" onClick={onClick} right="10%" className="from-righ">
        <FontAwesomeIcon icon={faAngleRight as any} />
      </Arrow>
    );
  };

  const items = data.map((item, idx) => {
    return (
      <div
        key={idx}
        className="text-white my-auto text-center overflow-visible flex flex-col gap-[1vw] md:gap-[2vh] h-full w-full md:w-[50%]"
      >
        <a href={item.link} className="block">
          <img
            src={item.img}
            alt="ffm image"
            className="transition-all w-5/6 md:w-[25%] mx-auto object-cover"
          />
        </a>
        <div className="mt-5 md:mt-5">
          <h2 className="font-bold italic">{item.title}</h2>
          <a
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-secondary mt-[--space-btw-items] inline-block "
          >
            LISTEN NOW
          </a>
        </div>
      </div>
    );
  });

  return (
    <Container className="overflow-visible overscroll-none">
      {type === MusicSliderType.DEFAULT ? (
        <Slider
          dots={false}
          nextArrow={<ArrowNext />}
          prevArrow={<ArrowPrev />}
          slidesPerRow={1}
          slidesToShow={1}
        >
          {items}
        </Slider>
      ) : (
        <NormalSlider data={data} />
      )}
    </Container>
  );
}
